import React, { Component } from "react";
import Fade from "react-reveal";

class About extends Component {
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const profilepic =
      process.env.PUBLIC_URL + "/images/" + this.props.data.image;
    const bio = this.props.data.bio;
    const street = this.props.data.address.street;
    const city = this.props.data.address.city;
    const state = this.props.data.address.state;
    const zip = this.props.data.address.zip;
    const phone = this.props.data.phone;
    const email = this.props.data.email;
    const resumeDownload =
      process.env.PUBLIC_URL + this.props.data.resumedownload;
    const highlights = this.props.data.highlights || [];

    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="three columns">
              <img
                className="profile-pic"
                src={profilepic}
                alt="Arush Adabala Profile Pic"
              />
            </div>
            <div className="nine columns main-col">
              <h2>About Me</h2>

              <p>{bio}</p>
              {highlights.length ? (
                <ul className="about-highlights">
                  {highlights.map((item) => (
                    <li key={item}>
                      <i className="fa fa-check-circle"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              ) : null}
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <span>{name}</span>
                    <br />
                    <span>
                      {street}
                      <br />
                      {city} {state}, {zip}
                    </span>
                    <br />
                    <span>{phone}</span>
                    <br />
                    <span>{email}</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a
                      href={resumeDownload}
                      className="button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-download"></i>View Resume
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
